import { createFileRoute } from '@tanstack/react-router';

import Chart3D from '@/components/Chart3D';
import { ConfigureChartButton } from '@/components/ConfigureChartButton';
import { DownloadButton } from '@/components/DownloadButton';
import { RangeFilterButton } from '@/components/RangeFilterButton';
import { useChartTitle } from '@/contexts/ChartContext';
import { sklanskyChubukovData } from '@/data/sklanskyChubukovData';
import { useChartDefaults } from '@/hooks/useChartDefaults';
import { usePageActions } from '@/hooks/usePageActions';
import { buildChartHeadMeta } from '@/lib/headMeta';

export const Route = createFileRoute('/sklansky-chubukov')({
  component: SklanskyChubukouRoute,
  head: () => buildChartHeadMeta({ chartData: sklanskyChubukovData, ogImagePath: '/og/sklansky-chubukov.png' }),
});

function SklanskyChubukouRoute() {
  useChartTitle(sklanskyChubukovData);
  useChartDefaults({ useLogScale: true, maxHeight: 4, showValues: true });
  usePageActions({
    secondary: () => (
      <>
        <RangeFilterButton />
        <DownloadButton />
      </>
    ),
    primary: () => <ConfigureChartButton />,
  });

  return <Chart3D data={sklanskyChubukovData} />;
}
